import { ISelfServeContextIdvResponse } from "@faire/web-api/indigofair/helpcenter/ISelfServeContextIdvResponse";
var IdvStatus = ISelfServeContextIdvResponse.IdvStatus;
export var idvPendingOrRejected = function idvPendingOrRejected(status) {
  return idvPending(status) || idvRejected(status);
};
export var idvPending = function idvPending(status) {
  return status === IdvStatus.NMI_SUBMITTED || status === IdvStatus.NMI_REQUESTED || status === IdvStatus.IDV_SUBMITTED || status === IdvStatus.IDV_REQUESTED || status === IdvStatus.UNVERIFIED_WITH_NO_ORDERS_WAITING_ON_REVIEW || status === IdvStatus.UNVERIFIED_WITH_ORDERS_WAITING_IN_REVIEW_QUEUE;
};
export var idvRejected = function idvRejected(status) {
  return status === IdvStatus.REJECTED;
};